<script setup lang="ts">
import Comment from './content.vue'

defineProps<{
  episodeId: number
  scriptId: number
}>()

const emit = defineEmits<{
  (e: 'close'): void
}>()
</script>

<template>
  <div
    class="relative z-50 flex h-full w-[25vw] shrink-0 overflow-hidden bg-black/40 text-white"
    @wheel.stop
    @touchmove.stop
  >
    <Comment v-memo="[episodeId]" :episode-id="episodeId" :script-id="scriptId" @close="emit('close')" />
  </div>
</template>
